import React, { useState } from 'react';
import './newsletter-signup.css';
import addToMailchimp from 'gatsby-plugin-mailchimp';

// import { scale } from '../utils/typography';

const Newsletter = (_props) => {
  const [email, setEmail] = useState('');
  const [resMessage, setResMessage] = useState(null);

  const _handleSubmit = async (e) => {
    e.preventDefault();
    const res = await addToMailchimp(email);
    setResMessage(res.msg);
  };

  return (
    <section className="newsletter">
      <div className="newsletter__content">
        <form onSubmit={_handleSubmit}>
          <h2>
            Subscribe to my{' '}
            <span
              style={{
                color: '#7ea16b',
              }}
            >
              newsletter.
            </span>{' '}
          </h2>
          <br />
          <h4>Original articles every other month or 6.</h4>
          <br />
          <br />

          <div className="newsletter__input-wrapper">
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              label="Email"
              type="email"
              name="email"
              autoComplete="email"
              placeholder="Enter your email"
              className="newsletter__input"
            />

            <button type="submit" className="newsletter__input-button">
              <i className="fas fa-paper-plane"></i>
            </button>
          </div>
          <small if={resMessage}> {resMessage} </small>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
